var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:_vm.widgetId,staticClass:"iframe-page",attrs:{"src":(_vm.url + "?_t=" + (new Date().getTime())),"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }